module.exports = __webpack_public_path__ + "img/btnback.a46dd147.jpg";